import React, { useState } from "react";
import "../../assets/css/responsive.css";
import "../../assets/css/offer.css";
import "../../assets/css/general.css";
import "../../assets/css/hamburger.css";

import Footer from "../../components/general/footer.jsx";
import NavBarApp from "../../components/general/NavBarApp";
import DailyTimeline from "../../components/calendar/daily-timeline";

const Main = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Données des missions
    const missions = [
        {
            role: "Cuisinier",
            start: "08:00",
            end: "12:00",
            place: "Hotel Fontaine",
            groupId: "A",
        },
        {
            role: "Cuisinier",
            start: "15:00",
            end: "18:00",
            place: "Hotel Fontaine",
            groupId: "A",
        },
        {
            role: "Serveur",
            start: "09:00",
            end: "14:00",
            place: "Hotel Fontaine",
            groupId: "B",
        },
        {
            role: "Serveur",
            start: "16:00",
            end: "20:00",
            place: "Hotel Fontaine",
            groupId: "B",
        },
        {
            role: "Barman",
            start: "06:00",
            end: "08:30",
            place: "Bar Parisien",
            groupId: "C",
        },
    ];

    return (
        <div className="main">
            <NavBarApp userType="entreprise" toggleMenu={toggleMenu} isOpen={isOpen} />
            <section className={"calendar-section"} >
                <DailyTimeline missions={missions} />
            </section>
        </div>
    );
};

export default Main;
